import { Icons } from '@/assets'
import { ROUTES } from '@/constants/routes'
import type { FC, SVGProps } from 'react';

export interface NavItemConfig {
    id: string
    icon: FC<SVGProps<SVGSVGElement>>;
    label: string
    path: string
}

export const MAIN_MENU:NavItemConfig[] = [
  { id: 'dashboard', icon: Icons.DashboardIcon, label: "Dashboard", path: ROUTES.MAIN.DASHBOARD },
  // { id: 'leads', icon: Icons.LeadsIcon, label: "Leads", path: ROUTES.MAIN.LEADS },
  { id: 'projects', icon: Icons.BankIcon, label: "Projects", path: ROUTES.MAIN.PROJECTS },
  { id: 'properties', icon: Icons.TowersIcon, label: "Properties", path: ROUTES.MAIN.PROPERTIES },
  // { id: 'inquiries', icon: Icons.InquiriesIcon, label: "Inquiries", path: ROUTES.MAIN.INQUIRIES },
  // { id: 'payments-dashboard', icon: Icons.WalletIcon, label: "Payments", path: ROUTES.MAIN.PAYMENTS_DASHBOARD },
  // { id: 'media-manager', icon: Icons.GalleryIcon, label: "Media & Visuals", path: ROUTES.MAIN.MEDIA_AND_VISUALS },
  // { id: 'team', icon: Icons.TeamIcon, label: "Team", path: ROUTES.MAIN.TEAM },
  // { id: 'analytics', icon: Icons.AnalyticsIcon, label: "Analytics", path: ROUTES.MAIN.ANALYTICS },
];

export const BOTTOM_MENU: NavItemConfig[] = [
  // { id: 'info', icon: Icons.InfoIcon, label: "Info", path: ROUTES.BOTTOM.INFO },
  // { id: 'settings', icon: Icons.SettingIcon, label: "Settings", path: ROUTES.BOTTOM.SETTINGS },
];
